import { Button } from "@light-technology/components";
import { exitStaffSession } from "../utilities/staffSession";

export const StaffSessionExpired = () => {
  const handleReturn = () => {
    exitStaffSession();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary/95">
      <div className="flex flex-col items-center gap-lg p-xl text-center">
        <h1 className="text-display-sm font-semibold text-primary">
          Session Expired
        </h1>
        <p className="text-md text-secondary">
          Your staff session has expired. Please return to the admin dashboard.
        </p>
        <Button color="primary" onClick={handleReturn}>
          Return to admin
        </Button>
      </div>
    </div>
  );
};
